import { useEffect, useState } from "react";
import { getHeroDocuments, type HeroDocument } from "@/lib/projectOverview";
import { OverviewCard } from "@/projectOverview/OverviewCard";

export function HeroDocumentsSection({ orderId }: { orderId: number }) {
  const [docs, setDocs] = useState<HeroDocument[] | null>(null);

  useEffect(() => {
    let cancelled = false;
    void getHeroDocuments(orderId)
      .then((list) => {
        if (!cancelled) setDocs(Array.isArray(list) ? list : []);
      })
      .catch(() => {
        if (!cancelled) setDocs([]);
      });
    return () => {
      cancelled = true;
    };
  }, [orderId]);

  if (docs === null) {
    return (
      <OverviewCard title="Hero-Dokumente">
        <p className="text-sm text-label-tertiary">Lade …</p>
      </OverviewCard>
    );
  }

  if (!docs.length) return null;

  return (
    <OverviewCard title="Hero-Dokumente">
      <ul className="space-y-1 text-sm">
        {docs.map((doc, idx) => {
          const label = doc.name || doc.title || `Dokument ${idx + 1}`;
          const href = doc.download_url || doc.url;
          return (
            <li key={String(doc.id ?? idx)}>
              {href ? (
                <a
                  href={String(href)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-accent hover:underline"
                >
                  {label}
                </a>
              ) : (
                <span className="text-label">{label}</span>
              )}
            </li>
          );
        })}
      </ul>
    </OverviewCard>
  );
}
